import {EventCustomAction, EventCustomLabel, EventCustomParameters} from '_types'
import {analyticsEventCustom} from './event-custom'

interface Parameters {
    action: EventCustomAction
    label: EventCustomLabel
    hierarchy: string
    menuTemplate?: string
}

/**
 * Tracks a menu click event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 * @param {string} params.hierarchy - Menu hierarchy of the event.
 * @param {string} params.menuTemplate - Menu template of the event.
 */
export function analyticsEventMenuClick({action, label, hierarchy, menuTemplate}: Parameters) {
    const eventDetails: EventCustomParameters = {
        category: 'Menu Click',
        action: action,
        label: label,
        menuHierarchy: hierarchy,
        menuTemplate: menuTemplate,
    }

    analyticsEventCustom(eventDetails)
}
